module.exports = __webpack_public_path__ + "img/Mazda.379f52a0.png";